import {
  PENDING,
  ACTIVE,
  ON_CALL,
  COMPLETED,
  ON_HOLD,
  REJECTED,
  CANCELED,
  CONFIRMED
} from './Status';

export default {
  [PENDING]: 'Pending',
  [ACTIVE]: 'Approved',
  [ON_CALL]: 'On Call',
  [CONFIRMED]: 'Confirmed',
  [COMPLETED]: 'Completed',
  [ON_HOLD]: 'Draft',
  [REJECTED]: 'Rejected',
  [CANCELED]: 'Canceled'
};
